import { ETranscoderOutputFormat } from '@vxui/common';
import { TFunction } from 'i18next';
import { iso6392, Language } from 'iso-639-2';

export type TSelectItem = {
  label: string;
  value: number | string;
};

export type CodecItem = TSelectItem & { profiles: TSelectItem[] };

export const channelItems = (t: TFunction): TSelectItem[] => {
  return [
    { label: t('transcoder.passthrough'), value: 0 },
    { label: '2.0', value: 2 },
    { label: '5.1', value: 6 },
  ];
};

const extraLangList = {
  org: { name: 'Original', iso6392B: 'org' },
};

export const languageItems = ((): Record<string, Language> => {
  const isoLangList = iso6392.reduce<Record<string, Language>>((list, lang) => {
    // get languages from ISO639-1 list and `Undefined`
    if (lang.iso6391 || lang.iso6392B === 'und') {
      // if name has aliases take only first one e.g. Divehi;Dhivehi;Maldivian -> Divehi
      // remove additional comments added in brackets e.g. Greek (1453-) -> Greek
      return { ...list, [lang.iso6392B]: { ...lang, name: lang.name.split(';')?.[0].split('(')?.[0] } };
    }
    return list;
  }, {});
  return { ...isoLangList, ...extraLangList };
})();

export const resolutionItems: TSelectItem[] = [
  { label: '2160p (4K)', value: '3840x2160' },
  { label: '1440p', value: '2560x1440' },
  { label: '1080p (FullHD)', value: '1920x1080' },
  { label: '720p', value: '1280x720' },
  { label: '540p', value: '960x540' },
  { label: '480p', value: '854x480' },
  { label: '360p', value: '640x360' },
  { label: '270p', value: '480x270' },
];

export const deinterlacingAlgorithmItems: TSelectItem[] = [
  { label: 'Adaptive', value: 'adaptive' },
  { label: 'Yadif', value: 'yadif' },
];

export const fpsItems: TSelectItem[] = [
  { label: '25', value: '25' },
  { label: '50', value: '50' },
];

export const videoCodecsItems: Record<string, CodecItem> = {
  h264: {
    label: 'h264',
    value: 'h264',
    profiles: [
      { label: 'main', value: 'main' },
      { label: 'high', value: 'high' },
    ],
  },
  h265: {
    label: 'h265',
    value: 'h265',
    profiles: [
      { label: 'main', value: 'main' },
      { label: 'main10', value: 'main10' },
    ],
  },
};

export const codecPassthroughValue = 'passthrough';

export const audioCodecsItems: TSelectItem[] = [
  { label: 'aac', value: 'aac' },
  { label: 'ac3', value: 'ac3' },
  { label: 'Passthrough', value: codecPassthroughValue },
];

export const sampleRatesItems: TSelectItem[] = [
  { label: '44,1', value: 44100 },
  { label: '48', value: 48000 },
  { label: '96', value: 96000 },
];

export const outputFormatItems: TSelectItem[] = [
  { label: ETranscoderOutputFormat.mp4, value: ETranscoderOutputFormat.mp4 },
  { label: ETranscoderOutputFormat.mpegts, value: ETranscoderOutputFormat.mpegts },
];
